import {
	IssuerHolding,
	MipGroupHoldingResponse,
	SecurityHolding,
	SecurityTypeHolding,
} from '@dealstack/shared/lib/generated';
import { ColumnDef } from '@tanstack/react-table';

export type CapTableColumn = ColumnDef<CapTableRow, string | number | undefined>;
export type CapTableRow =
	| MipGroupHoldingResponse
	| IssuerHolding
	| SecurityTypeHolding
	| SecurityHolding;

export enum StaticColumn {
	INSTRUMENT = 'instrument',
	TOTAL_SECURITIES = 'total_securities',
}
